module.exports = __webpack_public_path__ + "static/img/ucenter_logo.9fb8971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ucenter_logo.png
// module id = QCcM
// module chunks = 3